import { render, staticRenderFns } from "./SectionContacts.vue?vue&type=template&id=1c894839&"
import script from "./SectionContacts.vue?vue&type=script&lang=js&"
export * from "./SectionContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports